import { render, staticRenderFns } from "./layout-vertical.md?vue&type=template&id=e371b186&"
import script from "./layout-vertical.md?vue&type=script&lang=js&"
export * from "./layout-vertical.md?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/code/core/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('e371b186')) {
      api.createRecord('e371b186', component.options)
    } else {
      api.reload('e371b186', component.options)
    }
    module.hot.accept("./layout-vertical.md?vue&type=template&id=e371b186&", function () {
      api.rerender('e371b186', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "website/views/plugin/legend/layout-vertical.md"
export default component.exports